/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the 20-20-20 rule?`)
};

const es_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es la regla 20-20-20?`)
};

const de_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist die 20-20-20-Regel?`)
};

const nl_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de 20-20-20-regel?`)
};

const fr_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu’est-ce que la règle du 20-20-20 ?`)
};

const it_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è la regola del 20-20-20?`)
};

const pt_br2_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a regra 20-20-20?`)
};

const pt_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a regra 20-20-20?`)
};

const ja_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20-20-20ルールとは何ですか？`)
};

const zh_timer_u20m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是20-20-20法则？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u20m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u20m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u20m_faq3_q", locale)
	if (locale === "en") return en_timer_u20m_faq3_q(inputs)
	if (locale === "es") return es_timer_u20m_faq3_q(inputs)
	if (locale === "de") return de_timer_u20m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u20m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u20m_faq3_q(inputs)
	if (locale === "it") return it_timer_u20m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u20m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u20m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u20m_faq3_q(inputs)
	return zh_timer_u20m_faq3_q(inputs)
};